import { Component, OnInit } from '@angular/core';
import { AppService } from 'src/app/services/app.service';
import { StorageService } from 'src/app/services/storage.service';

declare var googleTranslate:any;
declare var languages:any;
declare var google:any;

@Component({
  selector: 'lang-list',
  templateUrl: './lang-list.component.html',
  styleUrls: ['./lang-list.component.scss']
})
export class LangListComponent implements OnInit{

  public data:any = [];
  public configuration:any = null;
  public selected = null;
  public comboTranslate:any = null;
  public lang:any = '';
  public width:any = null;
  public showMenu:any = false;

  constructor(
    public app: AppService,
    public storage: StorageService
  ){}
 
  /**
   * 
   * Click
   * 
   */
  _click(lang:any){

    this.storage.setLanguage(lang); 
    this.selected = lang;

    var url = window.location.href;   

    var dataUrl = url.split("?");   
    
    if(dataUrl.length == 1){
      url += '?lang='+lang;    
    }else{
      url = dataUrl[0]+"?lang="+lang;
    }
    this.lang = lang.lang;  
    this.changeCombo(lang); 
  
       

  }
  /**
   * 
   * Change combo
   * 
   * @param lang 
   * 
   */
  changeCombo(lang:any){ 

    this.comboTranslate = document.getElementById("google_translate_element").querySelector(".goog-te-combo");

    this.comboTranslate.value = lang;
    this.changeEvent(this.comboTranslate);
    
    
  }
  /**
   * 
   * Change
   * 
   * @param el 
   * 
   */
  changeEvent(el) {
    if (el.fireEvent) {
        el.fireEvent('onchange');
    } else {
        var evObj = document.createEvent("HTMLEvents");

        evObj.initEvent("change", false, true);
        el.dispatchEvent(evObj);
    }
  }
  /**
   * 
   * Select
   * 
   * 
   */
  select(){

    this.selected = this.storage.getLanguage(); 

    if(this.selected == null){

      this.selected = "pt";

    }

    this.lang = this.selected;
    this.changeCombo(this.lang); 

  }
  /**
   * 
   * Init
   * 
   */
  ngOnInit(): void {
   this.select();
  }

}
